module.exports = __webpack_public_path__ + "img/lv4.98dc61c0.png";